import { useCallback, useMemo } from "react";
import { faRobot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQuery, useMutation } from "react-query";
import { getProspectList } from "../../services/insights";
import { Dialog } from "../../components/Dialog";
import { ButtonProps } from "@mui/material/Button";
import { Table } from "../../components/Table";
import { format } from "date-fns";
import { useDialogConfirmation } from "../../hooks/useDialogConfirmation";
import { useToast } from "../../hooks/useToast";
import { updateNotShow } from "../../services/insights";

function ModalSelecionarFiltro(props) {
  const dialog = useDialogConfirmation();
  const toast = useToast();

  const { data: listaFiltro = [], isFetching: isLoadingInsights } = useQuery(
    "getProspectList",
    getProspectList
  );

  const handleClose = useCallback(() => {
    props.onClose();
  }, [props]);

  const execUpdateAudience = useMutation(
    async (param1: any) => {
      const response = await updateNotShow(param1.idList, param1.not_show);

      return response;
    },
    {
      onSuccess: () => {
        toast.show("Sucesso ao cadastrar audiência!", { severity: "success" });
        handleClose();
      },
      onError: () => {
        toast.show("Erro ao cadastrar audiência!", {
          severity: "error",
        });
      },
    }
  );

  async function excludeAutomaticAudience(rowData: any) {
    const obj = { idList: rowData.idListProspectei, not_show: 1 };
    try {
      await execUpdateAudience.mutateAsync(obj);
    } catch (err) {
      console.log({ err });
    }
  }

  const handleDialogDeleteInsight = useCallback(
    (row: any) => {
      dialog.show("Aviso", "Deseja excluir esta lista permanentemente?", {
        onConfirmate: async () => {
          props.onDelete(row.idListProspectei);
          dialog.close();
          handleClose();
        },
      });
    },
    [dialog, props, handleClose]
  );

  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Fechar",
        onClick: handleClose,
      },
    ];
  }, [handleClose]);

  const filter = () => {
    let list = [];
    for (let i = 0; i < listaFiltro.length; i++) {
      if (listaFiltro[i].not_show !== 1) {
        list.push(listaFiltro[i]);
      }
    }
    return list;
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      title="Audiências"
      open={props.open}
      actions={actions}
      onClose={handleClose}
    >
      <Table
        search
        isLoading={isLoadingInsights}
        onRowClick={(columns, data) => props.onSelect(data)}
        actions={[
          {
            icon: "delete",
            tooltip: "Excluir filtro",
            onClick: (_, rowData) => {
              if (rowData.nome_cluster === "AUTOMACAO") {
                dialog.show(
                  "Aviso",
                  "Deseja excluir esta lista permanentemente?",
                  {
                    onConfirmate: async () => {
                      await excludeAutomaticAudience(rowData);
                      dialog.close();
                    },
                  }
                );
              } else {
                handleDialogDeleteInsight(rowData);
              }
            },
          },
        ]}
        columns={[
          {
            title: "Audiência",
            field: "nameList",
            render: (row) => (
              <span style={{ display: "flex", alignItems: "center" }}>
                {row.automacao && (
                  <FontAwesomeIcon
                    style={{ marginRight: "1vw" }}
                    icon={faRobot}
                  />
                )}
                {row.nameList}
              </span>
            ),
          },
          { title: "Cluster", field: "nome_cluster" },
          {
            title: "Data",
            field: "dataFilter",
            render: (row) => (
              <span>
                {row.dateFilter
                  ? format(
                      new Date(row.dateFilter?.replace("Z", "")),
                      "dd/MM/yyyy HH:mm"
                    )
                  : ""}
              </span>
            ),
          },
        ]}
        data={filter()}
      />
    </Dialog>
  );
}

export default ModalSelecionarFiltro;
